<template>
    <div class="page" id="mixed-notes">
        <div class="decorative-texture top">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <div class="decorative-texture position-bottom movil-only">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <vue-snotify></vue-snotify>
        <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
        <mnavbar @menuVisible="menuVisible"></mnavbar>

        <div id="wrapper" :class="[{ 'active': hide }]">
            <!-- Sidebar -->
            <div id="sidebar-wrapper" :class="[{ 'top0': classTop }]">
                <nav>
                    <ul class="sidebar-nav">
                        <li class="sidebar-brand">
                            <a href="#" @click.prevent="() => { }"><span>Mis Notificaciones*</span></a>
                        </li>
                        <li v-for="(b, index) in busquedas" :key="b.table">
                       
                            <a :class="[{ 'selected': customSearch.table == b.table }]" href="#"
                                @click.prevent="selectSearch(b, index,true)">
                                <span>
                                    {{ getKeywords(b.query.keywords) }}
                                </span>
                               
                            </a>
                        </li>
                       
                    </ul>
                </nav>

            </div>
            <!-- Page content -->
            <div id="page-content-wrapper">
                <!-- vista para nueva busqueda  -->
                <div class="container-fluid noPadding" >
                    <div class="toolBar">
                        <div class="row">
                            <div class="col">
                                <h2 class="toolBarTitle">
                                    <button :class="['button', 'buttonTool', 'tooltip', { 'oculto': true }]"
                                        :data-tooltip="label" @click="hideSearches">
                                        <font-awesome-icon :icon="flecha" />
                                    </button>
                                    <button :class="['button', 'buttonTool', 'tooltip', { 'oculto': false }]"
                                        data-tooltip="Regresar" @click="toRegresar">
                                        <font-awesome-icon :icon="flecha" />
                                    </button>
                                    DISEÑO DE ALERTAS POR WHATSAPP
                                </h2>
                            </div><!-- col --->
                            <div class="toolActions col-auto " v-if = "false">
                                <div class="separator"></div>
                                <div class="keywords">
                                    <button class="button buttonTool tooltip" data-tooltip="Nueva notificación"
                                        @click="agregaNotificacion()">
                                        <font-awesome-icon icon="plus" />
                                    </button>
                                    <button class="button buttonTool tooltip" v-if="seleccionActivo" data-tooltip="Eliminar notificación"
                                        @click="borrarBusqueda">
                                        <font-awesome-icon icon="trash" />
                                    </button>
                                </div><!-- keywords buttons -->
                            </div><!-- toolActions -->
                        </div><!-- row -->
                    </div><!-- toolBar -->
                    <div class="row justify-content-center">
                        <div :class="['col-sm-12', { 'col-md-12': !hide }, { 'col-md-10': hide }, { 'col-lg-12': !hide }, { 'col-lg-10': hide }, { 'col-xl-8': !hide }, { 'col-xl-7': hide }]">
                            <div class="card head-card" style="margin-top: 4%">
                                <div class="title-card">
                                        <h4>{{ labelTitu }}</h4>
                                    </div>
                                    <div class="card-content">
                                        <div class="row">
                                            <div class="col-12 mb-2 justify-content-center">
                                                Estimado cliente, bienvenido a su Asistente de Alertas
                                                Newscast por WhatsApp, herramienta con la que podrá
                                                recibir las notas de manera oportuna con links activos
                                                para ser consultadas desde su dispositivo móvil.
                                            </div>
                                            <div class="col-sm-12 col-md-6 mb-2 mt-3">
                                                <div class="inputype Keywords-input">
                                                    <form>
                                                        <h4 class="interiorTitle">*Alerta</h4>
                                                        <input type="text " v-model="form.alerta"
                                                            placeholder="Alerta" :disabled="AlectActivo"/>
                                                        <span class="interiorTitle">
                                                            Capture una palabra, o varias si requiere hacer
                                                            una alerta cruzada, separadas por una "coma"
                                                        </span>
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 mb-2 mt-3">
                                                <div class="inputype Keywords-input">
                                                    <form>
                                                        <h4 class="interiorTitle">*Frecuencia</h4>
                                                        <select class="dselected" v-model="form.frecuencia" >
                                                            <option v-for="frecuencia in dataFrecuencia" :key="frecuencia.cv" :value="frecuencia.cv">
                                                                    {{ frecuencia.op }}
                                                            </option>
                                                        </select>
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12 mb-2 mt-3">
                                                <div class="inputype Keywords-input mt-3">
                                                    <form>
                                                        <h4 class="interiorTitle">*Fuentes: </h4>
                                                        <input type="text " v-model="mediosMostrar"
                                                            placeholder="Fuentes seleccionadas" disabled />
                                                    </form>
                                                </div>
                                                <div class="Keywords-button-container">
                                                    <button :class="[
                                                            'button',
                                                            'fluid',
                                                            'alternative',
                                                            'noMargin',
                                                        ]" @click="abrirModalMedio">
                                                        Seleccionar Fuentes
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12 mb-2 mt-3" v-if="mediosMostrar.length > 0">
                                                <h4 class="interiorTitle">Programas: </h4>
                                                <div class="Keywords-button-container">
                                                    <button :class="[
                                                            'button',
                                                            'fluid',
                                                            'alternative',
                                                            'noMargin',
                                                           
                                                        ]" @click="abrirModalP">
                                                        {{ activeP?"Ocultar selección de programas personalizado":"Seleccionar Programas de forma personalizado"}}
                                                     
                                                    </button>
                                                </div>
                                                <div class="row" v-if="activeP">
                                                    <div class="col-12" v-for="(item, index) in mediosProgramas" 
                                                            :key="index">
                                                        <SeleccionarP :media="item" 
                                                                :programasSeleccionados="programasSeleccionados"
                                                                :fiparamsCreate="fiparamsCreate" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12 mb-2 mt-3">
                                                <div class="Keywords-button-container">
                                                    <button v-if="!seleccionActivo" :class="[
                                                                'button',
                                                                'fluid',
                                                                'alternative',
                                                                'noMargin',
                                                            ]" @click="actualizar">
                                                        Guardar
                                                    </button>
                                                    <button v-if="seleccionActivo" :class="[
                                                                'button',
                                                                'fluid',
                                                                'alternative',
                                                                'noMargin',
                                                            ]" @click="actualizar">
                                                        Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <ModalMedio :active="active" :cancelar="abrirModalMedio" :error="error" :guardar="guardarModal" v-if="modaDAT"
                        :permisos="mediosPermisos" :slMedios="mediosPermisos" :medioSelect ="mediosselect2" />
                        <confirm :show="show" :smsModal="smsModal" @aceptar="deleteSearch" @cancelar="cancelDelete"></confirm>
                </div>
                <!-- vista para visualización de notas  -->
            </div>
        </div>
    </div>
</template>

<script>
import SideMenu from '@/components/sideMenu'
import mnavbar from '@/components/mnavbar'
import search from "@/components/search";
import ModalMedio from "./components/medios.vue";
import SeleccionarP from "./components/programas.vue";
import confirm from "@/components/confirm";
import busquedaCompleta from "@/pages/WizzardBusqueda";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faPlus,
    faCaretRight,
    faCaretLeft,
    faTrash,
    faCloudDownloadAlt,
    faFolderPlus,
    faPaperPlane,
    faEdit
} from "@fortawesome/free-solid-svg-icons";

import moment from "moment-timezone";
library.add(faPlus)
library.add(faCaretRight)
library.add(faCaretLeft)
library.add(faCloudDownloadAlt);
library.add(faTrash);
library.add(faFolderPlus);
library.add(faPaperPlane);
library.add(faEdit);

export default {
    components: {
        mnavbar,
        SideMenu,
        search,
        confirm,
        ModalMedio,
        SeleccionarP,
    },
    data() {
        return {
            //sidemenu
            menuOn: false,
            //sidemenu (busquedas)
            hide: true,
            classTop: false,
            flecha: "caret-left",
            label: "Ocultar Búsquedas",
            form: {
                alerta: "",
                frecuencia: null,
                fuentes: [],
            },
            //axios
            url: this.$store.getters.getMainUrl,
            providerID: this.$store.state.userInfo.net,
            // historial de busquedas
            busquedas: [],
            LastEvaluatedKey2: null,
            customSearch: {},
            customIndexSearch: -1,
            //notas
            items: [],
            LastEvaluatedKey: 0,
            total: 0,
            limit: 18,
            isEmpty: false,
            //selectnotas
            options: [{ label: 'Modo Gráfico', value: 1 }, { label: 'Modo Texto', value: 2 }, { label: 'Escaleta', value: 3 }],
            view: 3,
            from2: '',
            //confirmDelete
            show: false,
            smsModal: "¿Desea eliminar ésta notificación?",
            //exportFile
            isActive: false,
            //email
            mediosPermisos: [],
            emailModal: false,
            editing: false,
            mode: 1 ,//1:fast,2:especific fi
            dataFuentes :[],
            dataFrecuencia:[],
            mediosMostrar: [],
            active : false,
            activeP: false,
            mediosProgramas: [],
            fiSelect: {},
            labelTitu : "Agregar notificación",
            fiParams: {},
            mediosselect2 : [],
            seleccionActivo : false,
            key:null,
            AlectActivo : false,
            modaDAT : false
        }
    },
    computed: {
        token() {
            return this.$store.getters.getToken;
        },
        key_tabla() {
           let  key = this.$store.state.notificationWhatsApp.table_busqueda+"_"+this.$store.state.notificationWhatsApp.key_busqueda
            return key;
        },
    },
    mounted() {
     this.getCategoria();
    },
    async  beforeMount() {
        var r = await this.getPermisosFeeds();
        if (r.success) {
            this.mediosPermisos = r.data;
        }
        this.getSearches();
        this.load()
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
    toRegresar(){
        this.$router.push("/busquedas");
    },
        async  load() {
            if(this.$store.state.notificationWhatsApp.active){
                if(this.$store.state.notificationWhatsApp.action == "edit"){
                  //await  this.getSearchesNotification();
                  var r = await this.saveSearch1();
                  if (r.success){
                    this.activeP = false;
                    this.AlectActivo = true;
                    this.mediosselect2 = Object.keys(r.data.fuentes);
                    this.guardarModal(this.mediosselect2)
                    //this.form.alerta = r.data.keyword;
                    this.form.alerta = this.$store.state.notificationWhatsApp.keywords;
                    this.form.frecuencia = r.data.frecuencia;          
                    var setNotific ={
                            key_busqueda : this.$store.state.notificationWhatsApp.key_busqueda,
                            table_busqueda :  this.$store.state.notificationWhatsApp.table_busqueda,
                            action : "edit",
                            keywords : r.data.keyword,
                            fuentes : r.data.fuentes,
                            active:true,
                            frecuencia : r.data.frecuencia
                    }
                    this.$store.commit('setNotificacionWp', setNotific);
                    this.modaDAT = true;
                  }else{
                    this.activeP = false;
                    this.AlectActivo = true;
                    this.mediosselect2 = Object.keys(this.$store.state.notificationWhatsApp.fuentes);
                    let fi = Object.keys(this.$store.state.notificationWhatsApp.fuentes);
                    this.guardarModal(fi)
                    this.form.alerta = this.$store.state.notificationWhatsApp.keywords;
                    this.form.frecuencia = this.$store.state.notificationWhatsApp.frecuencia;
                    this.modaDAT=true;
                  }
                }
                if(this.$store.state.notificationWhatsApp.action == "new"){
                    this.activeP = false;
                    this.AlectActivo = true;
                    
                    this.mediosselect2 = Object.keys(this.$store.state.notificationWhatsApp.fuentes);
                    let fi = Object.keys(this.$store.state.notificationWhatsApp.fuentes);
                    this.guardarModal(fi)
                    this.form.alerta = this.$store.state.notificationWhatsApp.keywords;
                    this.form.frecuencia = this.$store.state.notificationWhatsApp.frecuencia;
                    this.modaDAT=true;
                }
            }
        },
        async saveSearch1(){
            let keyt =  this.$store.state.notificationWhatsApp.table_busqueda+"_"+this.$store.state.notificationWhatsApp.key_busqueda;
            
                var post_data = {
                token:this.token,
                key: keyt
                };
                return new Promise((resolve,reject)=>{
                var self = this;
                    axios.post(self.url + "getConfigWa", JSON.stringify(post_data))
                        .then(response => {
                            if (response.data.success) {
                                resolve({success:true,data:response.data.data})
                            }
                            else{
                                resolve({success:false,error:response.data.error})
                            }
                        })
                    .catch(function(error) {
                        resolve({success:false,error:error})
                    });
                })   
        },

        async  getSearchesNotification() {
            var self = this;
            self.busquedas=[];
            self.customSearch = [];
            var post_data = {
                token: self.token,
                key: self.key_tabla
                
            };
            axios.post(self.url + "getConfigWa", JSON.stringify(post_data))
                .then(function (response) {
                    if (response.data.success) {
                        var setNotific ={
                            key_busqueda : self.$store.state.notificationWhatsApp.key_busqueda,
                            table_busqueda :  self.$store.state.notificationWhatsApp.table_busqueda,
                            action : "edit",
                            keywords : response.data.data.keyword,
                            fuentes : response.data.data.fuentes,
                            active:true,
                            frecuencia : response.data.data.frecuencia
                        }
                        self.$store.commit('setNotificacionWp', setNotific);
                    }
                })
                .catch(function (error) {
                    self.error(error);
            });
        },

        async getCategoria() {
            var query = {
                token: this.token,
            }
            await axios
                .post(
                    this.url + "getOptionsWa",
                    query
                ) //petición
                .then((response) => {
                    if(response.data.success){
                        this.dataFuentes = response.data.data.fuentes;
                        this.dataFrecuencia = response.data.data.frecuencia;
                    }
                       
                })
                .catch(function (error) {
                    
                    // this.armarDataSet();
            });
        },
        menuVisible(menu) {
            this.menuOn = menu;
        },
        success(msg) {
            this.$snotify.success(msg, this.$store.state.success);
        },
        error(msg) {
            this.$snotify.error(msg, this.$store.state.error);
        },
        abrirModalMedio() {
            this.active = !this.active;
          
        },
        reset(){
            this.seleccionActivo = false;
            this.form.alerta="";
            this.form.frecuencia=null;
            this.form.fuentes=[];
            this.mediosMostrar=[];
            this.activeP = false;
           this.mediosselect2 = []
           this.labelTitu = "Agregar notificación"
        },
        guardarModal(fi) {
           
            this.mediosProgramas = [];
            this.form.fuentes = fi;
            fi.forEach((element) => {
                if (element == "T" || element == "TK" || element == "R" || element == "PD" || element == "FB" || element == "TW" || element == "Y" || element == "I" || element == "BN") {
                    this.mediosProgramas.push(element);
                }
            });
            this.mostrarMediosText();
        },
        async getPermisosFeeds() {
            var self = this;
            return new Promise((resolve) => {
                axios
                    .post(
                        this.url + "getPermisosFeeds",
                        JSON.stringify({ token: self.token })
                    ) //petición
                    .then((response) => {
                        self.isLoading = false;
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        self.isLoading = false;
                        var response = { success: false, error: error };
                       
                        resolve(response);
                    });
            });
        },
        mostrarMediosText() {
            this.mediosMostrar = [];
            this.form.fuentes.forEach((element) => {
                // mediosMostrar
                /*medios
                                                        TW, FB, Y,PD,T,R,TK
                                                        */
                switch (element) {
                    case "TW":
                        this.mediosMostrar.push(" Twitter");
                        break;
                    case "FB":
                        this.mediosMostrar.push(" Facebook");

                        break;
                    case "Y":
                        this.mediosMostrar.push(" Youtube");

                        break;
                    case "PD":
                        this.mediosMostrar.push(" Periodico Digital");

                        break;
                    case "T":
                        this.mediosMostrar.push(" Televisión");

                        break;
                    case "R":
                        this.mediosMostrar.push(" Radio");

                        break;
                    case "TK":
                        this.mediosMostrar.push(" Tiktok");

                        break;

                    default:
                        break;
                }
            });
        },
        abrirModalP() {
            this.activeP = !this.activeP;
        },
        programasSeleccionados(fi) {
            this.fiParams[fi.mt] = fi.arr
        },
        async actualizar() {
            var fiFinal = this.crearFi()
                var query = {
                    key: this.key_tabla,
                    token: this.token,
                    keyword: this.form.alerta,
                    frecuencia: this.form.frecuencia,
                    //fuentes: this.form.fuentes,
                    fuentes: fiFinal,
                    //programas: fiFinal,
                    //fiParams: this.fiParams,
                
                }
            if(this.form.alerta && this.form.frecuencia && Object.keys(fiFinal).length > 0){          
                    await axios
                        .post(
                            this.url + "updateConfigWa",
                            query
                        ) //petición
                        .then((response) => {
                            if (response.data.success) {
                                this.success("Registro exitoso");
                                this.getSearches();
                                this.reset()
                                this.$router.push("/busquedas");
                            }else{
                                this.error("Error de registro")
                            }

                        })
                        .catch(function (error) {
                            this.error(error)
                            // this.armarDataSet();
                    });
            }else{
                this.error("Seleccionar todos los campos con *")
            }
        },
        async guardar() {
            var fiFinal = this.crearFi()
                var query = {
                    token: this.token,
                    keyword: this.form.alerta,
                    frecuencia: this.form.frecuencia,
                    //fuentes: this.form.fuentes,
                    fuentes: fiFinal,
                    //programas: fiFinal,
                    //fiParams: this.fiParams,
                
                }
            if (this.form.alerta && this.form.frecuencia && Object.keys(fiFinal).length > 0){
                                   
                    await axios
                        .post(
                           this.url + "addConfigWa",
                            query
                        ) //petición
                        .then((response) => {
                            if (response.data.success) {
                               
                                this.success("Registro exitoso");
                                this.getSearches();
                                this.reset()
                                //this.$store.commit('clearNotificationWhatsApp');
                                this.$router.push("/busquedas");
                            }else{
                                this.error("Error de registro")
                            }

                        })
                        .catch(function (error) {
                         
                            this.error(error)
                            // this.armarDataSet();
                    });
            }else{
                this.error("Seleccionar todos los campos con *")
            }
        },
        crearFi() {
            var fFinal = {}
            this.form.fuentes.forEach(element => {
                if (this.fiParams[element]) {
                    fFinal[element] = this.fiParams[element]
                } else {
                    fFinal[element] = []
                }
            });
            return fFinal;
        },
       
        fiparamsCreate(fi) {
            this.fiParams[fi.mt] = fi.arr
        },
        getSearches() {
            var self = this;
            self.busquedas=[];
            this.customSearch = [];
            var post_data = {
                token: this.token,
                
            };
            axios.post(self.url + "listItemsWa", JSON.stringify(post_data))
                .then(function (response) {
                    if (self.busquedas.length == 0) {
                        self.busquedas = response.data.data.result;
                    } else {
                        self.busquedas = [].concat(self.busquedas, response.data.data.result);
                    }
                })
                .catch(function (error) {
                    self.error(error);
            });
        },
        hideSearches() {
            this.hide = !this.hide;
            if (this.hide) {
                this.label = "Mostrar Búsquedas";
                this.flecha = "caret-right"
            } else {
                this.label = "Ocultar Búsquedas";
                this.flecha = "caret-left"
            }
        },
        menuVisible(menu) {
            this.hide = true;
            this.menuOn = menu;
        },
        error(msg) {
            this.$snotify.clear();
            this.$snotify.error(msg, this.$store.state.error);
        },
        success(msg) {
            this.$snotify.clear();
            this.$snotify.success(msg, this.$store.state.success);
        },
        handleScroll: function () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollPosition == 0) {
                this.classTop = false;
            } else {
                this.classTop = true;
            }
        },
        //searches
        newSearch() {
            this.$store.commit('clearProyectConfig');
            this.customSearch = {};
            this.customIndexSearch = -1;
            this.clearNotas();
        },
        agregaNotificacion(){
            this.activeP = false;
            this.key = null;
            this.seleccionActivo  = false;
            this.mediosselect2 = [];
            let fi = [];
            this.guardarModal(fi)
            this.form.alerta = [];
            this.form.frecuencia = [];
            this.customSearch = [];
            this.labelTitu = "Agregar notificación";

        },

        selectSearch(item, index, logs= false) {
            var setNotific ={
              keywords : item.query.keywords,
              fuentes : item.query.fi,
              frecuencia : item.query.frecuencia,
              active:true
            }
            this.$store.commit('setNotificacionWp', setNotific);
            this.activeP = false;
            this.key= item.table;
            this.seleccionActivo  = true;
            this.mediosselect2 = Object.keys(item.query.fi);
            let fi = Object.keys(item.query.fi);
            this.guardarModal(fi)
            this.form.alerta = item.query.keywords;
            this.form.frecuencia = item.query.frecuencia
            this.customSearch = item;
            this.labelTitu = "Actualizar notificación para "+ item.query.keywords.toUpperCase();
          
        },
        clearNotas() {
            this.items = [];
            this.isEmpty = false;
            this.LastEvaluatedKey = 0;
            this.total = 0;
        },
        getKeywords(keywords) {
            var k = keywords.toString();
            return k;
        },
        //notas
        loadItems() {
            var self = this;
            var mi_query = this.customSearch.query;
            mi_query.limit = this.limit;
            mi_query.LastEvaluatedKey = this.LastEvaluatedKey;
            mi_query.token = this.token;
            mi_query.logs = this.customSearch.logs;
            axios.post(self.url + "queryElasticSearchFo", mi_query)
                .then(response => {
                    if (response.data.success) {
                        var query_result = response.data.data;
                        var data = query_result;
                        var arr_result = data.result;
                        self.total = data.total;
                        self.empty = self.total > 0 ? false : true;
                        self.LastEvaluatedKey =
                            self.limit + self.LastEvaluatedKey > self.total
                                ? -1
                                : self.limit + self.LastEvaluatedKey;
                        for (var j in arr_result) {
                            self.items = [].concat(self.items, arr_result[j]);
                        }
                        self.isEmpty = self.items.length > 0 ? false : true;
                        
                    }
                })
                .catch(function (error) {
                    self.isLoading = false;
                    self.error(error);
                });
        },
        setSelected(value) {
            this.view = value;
        },
        goToNote(obj) {
            var name = "";
            var fi = obj.fi ? obj.fi : obj.entrada;
            switch (fi) {
                case "FB":
                case "I":
                case "TW":
                    name = "notaEmbedded";
                    break;
                case "Y":
                    name = "notaYoutube";
                    break;
                case "PD":
                    name = "notaText";
                    break;
                case "T":
                case "R":
                    name = "notaVideo";
                    break;
                case "TK":
                    name = "notaTk";
                    break;
            }

            var p = { from: "busquedas", extraParams: { customSearch: this.customSearch, customIndexSearch: this.customIndexSearch } };
            this.$store.commit("saveBack2", p);

            var params = {
                id: obj.id ? obj.id : obj.key,
                fi: fi
            };
            if (obj.entrada == "TK") {
                params = {
                    fi: fi,
                    id: obj.key
                };
            }

            this.$router.push({ name: name, params: params });
        },
        goToNotes() {

        },
        loadMore() {
            if (this.LastEvaluatedKey == -1) {
                this.$snotify.info("Ya no ha más notas", "Info");
            } else {
                this.loadItems();
            }
        },
        //button tools
        borrarBusqueda() {
            this.show = true;
        },
        cancelDelete() {
            this.show = false;
        },
        deleteSearch() {
            
            var post_data = {
                key: this.customSearch.table,
                token: this.token,
               
            };
            var self = this;
            axios.post(self.url + "deleteConfigWa", JSON.stringify(post_data))
                .then(response => {
                    self.show = false;
                    if (response.data.success) {
                        this.getSearches();
                        this.reset();
                    }
                })
                .catch(function (error) {
                    self.show = false;
                    self.error(error);
                });
        },
        //nueva busqueda
        buscar(query) {
            //guardamos busuqeda
            this.saveSearch(query);
        },
        saveSearch(query) {
            
            var post_data = {
                token: this.token,
                query: query,
                version: "v2" // EGM-DEV
            };
            var self = this;
            axios.post(self.url + "saveSearch", JSON.stringify(post_data))
                .then(response => {
                    if (response.data.success) {
                        self.busquedas.unshift(response.data.data);
                        self.customSearch = response.data.data;
                        self.customSearch.logs = true
                        self.customIndexSearch = 0;
                        
                        self.loadItems();
                    }
                })
                .catch(function (error) {
                    self.error(error);
                });
        },
        //EXPORT FILE (IVAN)
        exportFile() {
            this.isActive = true;
        },
        closeModal() {
            this.isActive = false;
        },
        exportCSV(fName) {
            if (fName.trim() == "") {
                this.error("Ingrese un Nombre");
                return 0;
            }
            this.closeModal();

            var that = this;
            var dat = JSON.stringify({
                token: that.token,
                query: that.customSearch.query,
                nombre: fName,
                version: "v2"
            });
            axios
                .post(that.url + "downloadCSV", dat)
                .then(function (response) {
                    
                    if (response.data.success == true) {
                        that.success(
                            "Se generó un nuevo archivo, en breve se encontrará en la sección de descargas",
                            "Success"
                        );
                    }
                })
                .catch(function (error) {
                    that.error(error);
                });
        },
        //guarda en carpeta
        saveNotes() {

            var p = { from: "busquedas" };
            this.$store.commit("saveBack2", p);

            this.$router.push({
                name: "guardarEnCarpeta",
                params: {
                    query: this.customSearch.query
                }
            });
        },
        //titulo bartool
        getMedio() {
            var arr = [];
            var query = this.customSearch.query;
            if (query.fi.FB) {
                arr.push("Facebook")
            }
            /* if (query.fi.I) {
                 arr.push("Instagram")
             }*/
            if (query.fi.TW) {
                arr.push("Twitter")
            }
            if (query.fi.PD) {
                arr.push("Portales digitales")
            }
            if (query.fi.R) {
                arr.push("Radio")
            }
            if (query.fi.T) {
                arr.push("Televisión")
            }
            if (query.fi.Y) {
                arr.push("Youtube")
            }
            if (query.fi.TK) {
                arr.push("Tiktok")
            }

            return arr.toString();

        },
        getFechas() {
            var query = this.customSearch.query;
            if(query.dias == null && query.fecha == null){
                var dias = query.dias; //dias atrás
                var fecha = moment();
                var fechaFin = moment.tz(fecha, 'America/Mexico_City').format('DD/MM/YYYY');
                var fecha2 = fecha.subtract(dias - 1, 'days');
                var fechaInicio = moment.tz(fecha2, 'America/Mexico_City').format('DD/MM/YYYY');
                var f = fechaFin + ' - ' +  fechaInicio;
                return f;
            }

            if (!isNaN(query.dias)) {
                var dias = query.dias; //dias atrás
                var fecha = moment();
                var fechaFin = moment.tz(fecha, 'America/Mexico_City').format('DD/MM/YYYY');
                var fecha2 = fecha.subtract(dias - 1, 'days');
                var fechaInicio = moment.tz(fecha2, 'America/Mexico_City').format('DD/MM/YYYY');
                var f = fechaInicio + ' - ' + fechaFin;
                return f;
            }
            else {
                var fechaIni = "";
                var fechaFin = "";
                if (query.fecha.ini) {
                    var arr = query.fecha.ini.split('-');
                    var anio = arr[0];
                    var mes = parseInt(arr[1]);
                    if (mes <= 9) mes = '0' + mes;
                    var dia = parseInt(arr[2]);
                    if (dia <= 9) dia = '0' + dia;
                    fechaIni = dia + '/' + mes + '/' + anio;
                }
                if (query.fecha.fin) {
                    
                    var arr = query.fecha.fin.split('-');
                    var anio = arr[0];
                    var mes = parseInt(arr[1]);
                    if (mes <= 9) mes = '0' + mes;
                    var dia = parseInt(arr[2]);
                    if (dia <= 9) dia = '0' + dia;
                    fechaFin = dia + '/' + mes + '/' + anio;
                }
                return fechaIni + '-' + fechaFin;
            }
            
            
        },
        //email
        enviar() {
            this.emailModal = true;
        },
        cancelarEnviar() {
            this.emailModal = false;
        },
        async sendEmail(obj) {
            var post_data = {
                token: this.token,
                query: this.customSearch.query,
                email: obj.email,
                type: "notas"
            };
            if (obj.subject != "") post_data["subject"] = obj.subject;

            if (obj.type == "correos") {

                if (obj.cc) post_data["cc"] = obj.cc;

                var self = this;

                axios.post(this.url + "sendMail", post_data)
                    .then(response => {
                        self.emailModal = false;
                        if (response.data.success) {
                            self.success("Email enviado");
                        } else {
                            self.error(response.data.error);
                        }
                    })
                    .catch(function (error) {
                        self.error(response.data.error);
                       
                    });
            } else {
              
                post_data.type = "grupos";
                var r = await this.sendEmails(post_data);
                this.emailModal = false;
                if (r.success) {
                    this.success("Email enviado");
                } else {
                    this.error(r.error);
                }
            }
        },
        async sendEmails(obj) {
            var post_data = {
                query: obj.query,
                token: this.token,
                type: obj.type,  //correo o grupos?
                items: obj.email, //array de correos o grupos
            }

            if (obj.subject) post_data.subject = obj.subject;
            var self = this;
            return new Promise((resolve) => {
                axios.post(self.url + "sendEmails", JSON.stringify(post_data))
                    .then(function (response) {
                        if (response.data.success)
                            resolve({ success: true })
                        else
                            resolve({ success: false, error: response.data.error })
                    })
                    .catch(function (error) {
                        resolve({ success: false, error: error })
                    });
            });
        },
        //edicion
        editarBusqueda() {
            this.editing = true;
            this.mode = 2;
            this.clearNotas();
        },
        update(data) {
            this.busquedas[this.customIndexSearch] = data;
            this.customSearch = data;
            this.selectSearch(this.customSearch, this.customIndexSearch,true);
        },
        getTotalLabel() {
            var label = this.total > 0 ? "(" + this.total + ")" : "";
            return label;
        },
        getFis(query) { //get fuentes de informacion para mostrar iconos en listado
            var fi = query.fi;
            var fiKeys = Object.keys(fi);
            return fiKeys;
        }
    }
}
</script>
<style scoped>
.checkAND label {
    width: 100%;
}

button[disabled],
html input[disabled] {
    cursor: default;
    background-color: #fff !important;
    border: 1px solid #00B99E;
    color: #062633 !important
}

.keywords-section .Keywords-input input {
    border: 1px solid #00B99E;
}

.keywords-section .Keywords-input input::placeholder {
    color: #062633;
}

.buttonTool {
    color: #fff;
    background: #00b99e;
    border-radius: 5px;
    border: none;
    padding: 5px 9px;
    font-size: 16px;
    z-index: 1000;
    max-height: 30px;
}

.buttonTool:hover {
    color: #062633;
    background: #ebf9ff;
    border-radius: 5px;
    border: none;
    padding: 5px 9px;
    font-size: 16px;
    z-index: 1000;
}

.button.tooltip:after {
    z-index: 1000;
}

#wrapper {
    padding-left: 250px;
    transition: all 0.4s ease 0s;
}

#sidebar-wrapper {
    margin-left: -250px;
    left: 250px;
    width: 250px;
    background: #062633;
    border-right: 1px solid #EBF9FF;
    position: fixed;

    overflow-y: scroll;
    overflow-x: hidden;

    z-index: 1000;
    transition: all 0.4s ease 0s;
    top: 60px;
    bottom: 0;
    scrollbar-width: thin;
    /* "auto" or "thin"  */
    scrollbar-color: #062633 #00B99E;
}

::-webkit-scrollbar {
    width: 12px;
}


::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px #00B99E;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 3px #00B99E;
}

.top0 {
    top: 0px !important;
}

#wrapper.active {
    padding-left: 0;
}

#wrapper.active #sidebar-wrapper {
    left: 0;
}

#page-content-wrapper {
    width: 100%;
    transition: all 0.4s ease 0s;
}

.sidebar-nav {
    position: absolute;
    top: 0;
    width: 250px;
    list-style: none;
    margin: 0;
    padding: 0;
    min-height: 100%;
}


.sidebar-nav li {
    margin: auto;
    width: 98%;
    line-height: 20px;
}

.sidebar-nav li a {
    border: 1px solid #00b99e;
    margin: 5px;
    border-radius: 5px;
    color: #ebf9ff;
    display: block;
    text-decoration: none;
    text-indent: 5px;
    word-wrap: break-word;
    padding-top: 5px;
    padding-bottom: 5px;
}


.sidebar-nav li a span {
    margin-left: 1%;
}

.sidebar-nav li a span svg {
    fill: #ebf9ff;
}

.sidebar-nav li a span:before {
    position: absolute;
    left: 0;
    color: #ebf9ff;
    text-align: center;
    width: 20px;
    line-height: 18px;
}

.sidebar-nav li a:hover,
.sidebar-nav li.active {
    color: #ebf9ff;
    background-color: #00b99e;
    text-decoration: none;
}

.selected {
    color: #ebf9ff;
    background-color: #00b99e;
    text-decoration: none;
}

.sidebar-nav li a:active,
.sidebar-nav li a:focus {
    text-decoration: none;
}

.sidebar-nav>.sidebar-brand {
    margin-bottom: 2% !important;
    height: 40px;
    font-size: 18px;
    width: 95%;
    margin: auto;
    border-bottom: 1px solid #ebf9ff;
}

.sidebar-nav>.sidebar-brand a {
    border: none;
    cursor: default;
    color: #fff;
}

.sidebar-nav>.sidebar-brand a:hover {
    background: none;
    color: #fff;
    border: none
}

#menu-toggle {
    text-decoration: none;
    float: left;
    color: #fff;
    padding-right: 15px;
}

@media (max-width:767px) {

    #wrapper {
        padding-left: 0;
    }

    #sidebar-wrapper {
        left: 0;
    }

    #wrapper.active {
        position: relative;
        left: 250px;
    }

    #wrapper.active #sidebar-wrapper {
        left: 250px;
        width: 250px;
        transition: all 0.4s ease 0s;
    }

    #menu-toggle {
        display: inline-block;
    }

}

.dropdown {
    text-align: center;
}

.end {
    width: 100%;
    height: 40px;
    line-height: 20px !important;
    text-indent: 0px !important;
}

.icons {
    text-align: center;
}

.iconsTitle svg {
    margin-right: 1%;
    fill: #00b99e !important;
}
</style>